import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Building2, Calendar, FileText, Download } from "lucide-react";
import Sidebar from "../components/Sidebar";
import { fetchComunicazione, fileUrl } from "../api";

const ComunicazioneDetailPage = () => {
  const { sub, slug } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    fetchComunicazione(sub, slug)
      .then(setItem)
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [sub, slug]);

  if (loading) {
    return <div className="max-w-3xl mx-auto px-4 py-20 text-center text-gray-400">Caricamento...</div>;
  }

  if (notFound || !item) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-20 text-center">
        <h1 className="font-serif-display text-3xl text-sq-navy">Comunicazione non trovata</h1>
        <Link to="/comunicazioni" className="text-sq-orange mt-4 inline-block">
          Torna alle comunicazioni
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 fade-in">
      <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
        <Link to="/" className="hover:text-sq-orange">Home</Link>
        <span>/</span>
        <Link to="/comunicazioni" className="hover:text-sq-orange">Comunicazioni societarie</Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <article className="lg:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <span className="bg-sq-orange text-white text-[11px] uppercase tracking-wide font-semibold px-3 py-1">
              {item.company}
            </span>
          </div>
          <h1 className="font-serif-display text-3xl text-sq-navy leading-tight">{item.title}</h1>
          <div className="flex items-center gap-5 text-sm text-gray-500 mt-4 pb-5 border-b border-sq">
            <span className="flex items-center gap-1"><Building2 size={14} /> {item.company}</span>
            <span className="flex items-center gap-1"><Calendar size={14} /> {item.date}</span>
          </div>

          <div className="bg-sq-light border border-sq rounded-sm p-5 mt-6 flex items-start gap-3">
            <FileText className="text-sq-orange mt-0.5" size={20} />
            <div>
              <p className="text-sm font-medium text-sq-navy">Comunicazione ufficiale</p>
              <p className="text-sm text-gray-600">{item.summary}</p>
            </div>
          </div>

          <div className="mt-6 space-y-5 text-[17px] leading-[1.8] text-gray-800">
            <p>
              In conformità alla normativa vigente e alle disposizioni regolamentari applicabili alle
              società quotate, si rende nota la presente comunicazione relativa a{" "}
              <strong>{item.company}</strong>.
            </p>
            <p>
              Il documento integrale, comprensivo dell'ordine del giorno e di tutte le informazioni di
              dettaglio, è disponibile presso la sede sociale, sul sito internet della società e tramite
              il meccanismo di stoccaggio autorizzato.
            </p>
            <p>
              La presente sezione raccoglie ed elabora in forma sintetica i contenuti pubblicati da fonti
              ufficiali, a fini esclusivamente informativi.
            </p>
          </div>

          {item.pdfUrl ? (
            <a
              href={fileUrl(item.pdfUrl)}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 bg-sq-navy hover:bg-sq-orange transition-colors text-white px-5 py-3 rounded-sm text-sm font-medium"
            >
              <Download size={16} /> Scarica documento ufficiale (PDF)
            </a>
          ) : (
            <button className="mt-8 inline-flex items-center gap-2 bg-sq-navy hover:bg-sq-orange transition-colors text-white px-5 py-3 rounded-sm text-sm font-medium">
              <Download size={16} /> Scarica documento ufficiale (PDF)
            </button>
          )}
        </article>
        <Sidebar showBottomAd={false} />
      </div>
    </div>
  );
};

export default ComunicazioneDetailPage;
